import { render, staticRenderFns } from "./EditFormEnumModelField.vue?vue&type=template&id=4c60e26e"
import script from "./EditFormEnumModelField.vue?vue&type=script&lang=js"
export * from "./EditFormEnumModelField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports